import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { NavigationItem } from '../shared/navigation';

interface MobileMenuProps {
  navigation: NavigationItem[];
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
}

export default function MobileMenu({
  navigation,
  isOpen,
  onClose,
  onLogout
}: MobileMenuProps): React.ReactElement | null {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, organizations } = useAuth();

  // Check if user is saasadmin
  const isSaasAdmin =
    user?.user_metadata?.global_role === 'saasadmin' ||
    organizations.some(org => org.role === 'saasadmin');

  // Check if we're in admin context
  const isAdminContext = location.pathname.startsWith('/admin');

  if (!isOpen) return null;

  return (
    <div className="border-t border-gray-200 bg-gray-50">
      {/* Context Switch for SaaS Admins with Organizations */}
      {isSaasAdmin && organizations.length > 0 && (
        <div className="px-4 py-3 border-b border-gray-200">
          <div className="flex rounded-md bg-gray-100 p-1">
            <button
              onClick={() => {
                navigate('/');
                onClose();
              }}
              className={`flex-1 text-sm font-medium py-2 px-3 rounded transition-colors ${
                !isAdminContext
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Clínica
            </button>
            <button
              onClick={() => {
                navigate('/admin');
                onClose();
              }}
              className={`flex-1 text-sm font-medium py-2 px-3 rounded transition-colors ${
                isAdminContext
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Admin
            </button>
          </div>
        </div>
      )}
      <nav className="px-4 py-2 space-y-1">
        {navigation.map(item => (
          <button
            key={item.name}
            onClick={() => {
              navigate(item.href);
              onClose();
            }}
            className={`flex items-center w-full px-3 py-2 text-base font-medium rounded-md transition-colors ${
              location.pathname === item.href ||
              (item.href !== '/' && location.pathname.includes(item.href))
                ? 'bg-blue-100 text-blue-700'
                : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
            }`}
          >
            <FontAwesomeIcon icon={item.icon} className="mr-3 h-5 w-5" />
            {item.name}
          </button>
        ))}
      </nav>
    </div>
  );
}
